import { ErrorBoundary } from 'react-error-boundary';
import { Route, Routes } from 'react-router-dom';

import ErrorLogger from '../../../providers/ErrorLogger';
import RouteGuard from '../../../routes/RouteGuard';
import RouteWithTitle from '../../../routes/RouteWithTitle';
import { CandidateProfile } from '../../candidateLayout/components/profile';
import CareerbuilderNew from '../../nativeSearch/careerbuilder/CareerBuilderNew';
import CareerBuilderEdgeNew from '../../nativeSearch/careerbuilderedge/CareerBuilderEdgeNew';
import CVLibraryNew from '../../nativeSearch/cvlibrary/CVLibraryNew';
import CWJobsNew from '../../nativeSearch/cwjobs/CWJobsNew';
import DiceSearchNew from '../../nativeSearch/dice/DiceSearchNew';
import JobServeNew from '../../nativeSearch/jobserve/JobServeNew';
import JobSiteNew from '../../nativeSearch/jobsite/JobSiteNew';
import MonsterSearchListNew from '../../nativeSearch/monster/MonsterSearchListNew';
import SourcingBots from '../../nativeSearch/sourcingBots';
import TechFetchSearchListNew from '../../nativeSearch/techfetch/TechFetchSearchListNew';
import JobBoardSearch from '../componets/JobBoardSearch';

export const JobBoardSearchRoutes = () => (
  <Routes>
    <Route
      path="/*"
      element={
        <RouteGuard>
          <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
            <JobBoardSearch />
          </ErrorBoundary>
        </RouteGuard>
      }
    />
  </Routes>
);

export const JobBoardSearchChildRoutes = () => (
  <Routes>
    <Route
      path="/dice"
      element={
        <RouteGuard>
          <DiceSearchNew />
        </RouteGuard>
      }
    />
    <Route
      path="/techfetch"
      element={
        <RouteGuard>
          <TechFetchSearchListNew />
        </RouteGuard>
      }
    />
    <Route
      path="/monster"
      element={
        <RouteGuard>
          <MonsterSearchListNew />
        </RouteGuard>
      }
    />
    <Route
      path="/careerBuilder"
      element={
        <RouteGuard>
          <CareerbuilderNew />
        </RouteGuard>
      }
    />

    <Route
      path="/careerbuilderedge"
      element={
        <RouteGuard>
          <CareerBuilderEdgeNew />
        </RouteGuard>
      }
    />
    <Route
      path="/cwJobs"
      element={
        <RouteGuard>
          <CWJobsNew />
        </RouteGuard>
      }
    />
    <Route
      path="/jobsite"
      element={
        <RouteGuard>
          <JobSiteNew />
        </RouteGuard>
      }
    />
    <Route
      path="/jobServe"
      element={
        <RouteGuard>
          <JobServeNew />
        </RouteGuard>
      }
    />
    <Route
      path="/cvlibrary"
      element={
        <RouteGuard>
          <CVLibraryNew />
        </RouteGuard>
      }
    />
    <Route
      path="/candidate-profile/:candidateId/:emailId"
      element={
        <RouteGuard>
          <CandidateProfile />
        </RouteGuard>
      }
    />
    <Route
      path="native-search/sourcing-bots"
      element={
        <RouteWithTitle title="Sourcing Bots- Wisestep">
          <RouteGuard>
            <SourcingBots />
          </RouteGuard>
        </RouteWithTitle>
      }
    />
  </Routes>
);
